import React, { Component } from "react";
import { Text, FlexContainer } from "src/components";
import { LicenseRenewalContainerContext } from "src/components/LicenseRenewalContainerContext";
import styled from "styled-components";
import CorrectGreen from "src/img/new/green-check.svg";
import { AccessCodeWrapper, AccessCodeBox } from "../LicenseActivation";
import { LICENSE_PAYMENT_SUCCESS } from "src/scenes/Subscription/forms/TierSelectionModal";

const SuccessImage = styled.img`
    width: 83px;
    height: 83px;

    @media (max-width: 768px) {
        width: 57px;
        height: 57px;
    }
`;

const SuccessTitle = styled(Text)`
    color: #23262D;
    font-weight: 500;
    font: normal normal bold 40px/53px Manrope;
    width: 50rem;

    @media (max-width: 768px) {
        text-align: center;
        font: normal normal bold 30px/39px Manrope;
        letter-spacing: 0px;
        color: #000000;
        opacity: 1;
        width: 100%;
        margin: 20px auto;
    }
`;

const InfoText = styled(Text)`
    color: black;
    font-weight: 500;
    font-size: 16px;
    width: 400px;
    line-height: 25px;
    margin: 10px 0;

    @media (max-width: 768px) {
        text-align: center;
        font: normal normal medium 16px/21px Manrope;
        letter-spacing: 0px;
        color: #000000;
        opacity: 1;
        width: 100%;
        padding: 0 10px;
    }
`;
class LicenseRenewalSuccess extends Component {
    static contextType = LicenseRenewalContainerContext;

    componentDidMount() {
        window.opener?.postMessage(
            { type: LICENSE_PAYMENT_SUCCESS },
            window.location.origin
        );
    }

    render() {
        const { accessToken } = this.context;
        const { durationNiceString } = this.props;

        return (
            <FlexContainer
                style={{
                    margin: "0 auto",
                    width: "100%",
                    maxWidth: "600px", 
                    padding: "0 1rem", 
                }}
            >
                <FlexContainer alignItems="center" padding="2rem 1rem" height="100%" style={{ flexDirection: "column" }}>
                    <br />
                    <SuccessImage src={CorrectGreen} alt="success" />

                    <SuccessTitle>
                        Purchase Successful!
                    </SuccessTitle>

                    <InfoText>
                        Your {durationNiceString} subscription is now active! <br /><br />
                        We’ve sent a copy of your purchase receipt to your email — please keep it for your records. <br /><br />
                        To start enjoying full access, simply relaunch the app and log in using your unique access code below. You’ll be prompted again when it’s time to renew your subscription.
                    </InfoText>

                    <Text size="20px" color="#612684" weight="bolder" style={{ textAlign: "center", margin: "10px 0" }}>
                        Your App Login Code:
                    </Text>

                    <AccessCodeWrapper>
                        <AccessCodeBox>{accessToken}</AccessCodeBox>
                    </AccessCodeWrapper>

                </FlexContainer>
            </FlexContainer>
        );
    }
}

export default LicenseRenewalSuccess;